module.exports = require("@trendmicro/react-anchor");


//////////////////
// WEBPACK FOOTER
// external "@trendmicro/react-anchor"
// module id = 3
// module chunks = 0